export default __webpack_public_path__ + "static/media/BeforePhoto12.e6945783.jpg";